import { getLinks } from '@/api/links'
export default {
    state: {
        links: [],

    },

    mutations: {

        SET_LINKS: (state, data) => {
            state.links = [...data]
        }

    },

    actions: {
        getLinks({ commit }) {

            return new Promise((resolve, reject) => {
                getLinks().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_LINKS', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },


    }
}